import {UserDefinedWidget} from '@models/pages/user-defined-page/user-defined-widget';
import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';

export class TemplatePageConfigurationDetails {
  widgetIds: number[] = [];
  widgets: UserDefinedWidget[] = [];
  statusSignals: TemplateStatusPageSignalDetails[] = [];

  statusSignalsDetails: Map<number, StatusEventSignalEventsDetails> = new Map<number, StatusEventSignalEventsDetails>();
}

export class TemplateStatusPageSignalDetails {
  signalId: number = -1;
  signalName: string = '';

}